import React from 'react'
import { Menu, Button } from 'antd'
import { PoweroffOutlined } from '@ant-design/icons'
import styled from 'styled-components/macro'
import { useDispatch, useSelector } from 'react-redux'
import { getSession } from '../../features/session/selector'
import { UserActions } from '../../features/user/actions'
import { MenuItem } from '../Menu'

const RightItem = styled(Menu.Item)`
  float: right;
`

const MenuItemWrapper = styled(Menu.Item)`
  padding: 0;
`

export const Header = () => {
  const dispatch = useDispatch()
  const session = useSelector(getSession)

  return (
    <div>
      <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>
        <MenuItemWrapper key="1">
          <MenuItem key="11" text="Home" link="/" />
        </MenuItemWrapper>
        <MenuItemWrapper key="2">
          <MenuItem key="12" text="Themes" link="/themes" />
        </MenuItemWrapper>
        <MenuItemWrapper key="3">
          <MenuItem key="13" text="Hooks" link="/hooks" />
        </MenuItemWrapper>
        <MenuItemWrapper key="4">
          <MenuItem key="14" text="Profiles" link="/profiles" />
        </MenuItemWrapper>
        <MenuItemWrapper key="5">
          <MenuItem key="15" text="Statistiche" link="/stats" />
        </MenuItemWrapper>
        <MenuItemWrapper key="6">
          <MenuItem key="16" text="Chats" link="/userchats" />
        </MenuItemWrapper>
        <RightItem>
          {session && session.id && (
            <Button
              icon={<PoweroffOutlined />}
              type="link"
              onClick={() => dispatch(UserActions.logout(`${session.id}`))}
            >
              Logout
            </Button>
          )}
        </RightItem>
      </Menu>
    </div>
  )
}
